import Authorize from 'components/common/authorize';
import React from 'react';
import ResultsServiceRequests from '../../results/results-service-requests';
import { APPS, COUNTS } from 'components/constants';
import { Expanding } from 'components/common/expanding';
import { PERMISSIONS } from 'components/constants';
import { WidgetTask } from 'components/dashboard/widget-task';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function ServiceRequestsTasks(props) {

	const params = useParams();

    const counts = useSelector((store) => store.admin.dashboard_counts);

    return (
		<div className="row mb-2 no-gutters results" >

			{/* TASKS ------------------------------------------------------------------------------------- */}

			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'unassigned-sr' }
					badge={ (params.appId == APPS.ASSETS.id) ? counts?.[COUNTS.ASSETS_REQUESTS_UNASSIGNED.id] ?? 0 : counts?.[COUNTS.SERVICE_REQUESTS_UNASSIGNED.id] ?? 0 }
					icon={ <i className="fa-duotone fa-solid fa-folder-xmark fa-3x"></i> }
					text={ 'Unassigned Service Requests' }
					value="unassigned-sr"
					onClick={ props.handleClick }
				/>
			</div>
			<div className="col p-1">
				<WidgetTask 
					active={ params.widget_id == 'inprogress-sr' }
					badge={ (params.appId == APPS.ASSETS.id) ? counts?.[COUNTS.ASSETS_REQUESTS_INPROGRESS.id] ?? 0 : counts?.[COUNTS.SERVICE_REQUESTS_INPROGRESS.id] ?? 0 }
					icon={ <i className="fa-duotone fa-solid fa-folder-grid fa-3x"></i> }
					text={ 'Service Requests in Progress' }
					value="inprogress-sr"
					onClick={ props.handleClick }
				/>
			</div>
			<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
				<div className="col p-1">
					<WidgetTask 
						active={ params.widget_id == 'completed-sr' }
						badge={ (params.appId == APPS.ASSETS.id) ? counts?.[COUNTS.ASSETS_REQUESTS_COMPLETED.id] ?? 0 : counts?.[COUNTS.SERVICE_REQUESTS_COMPLETED.id] ?? 0 }
						icon={ <i className="fa-duotone fa-solid fa-folder-check fa-3x"></i> }
						// icon={ <i className="fa-duotone fa-solid fa-file-invoice-dollar fa-3x"></i> }
						text={ 'Completed Ready to Invoice' }
						value="completed-sr"
						onClick={ props.handleClick }
					/>
				</div>
			</Authorize>

			{/* RESULTS TABLES ---------------------------------------------------------------------------- */}

			<Expanding open={ params.widget_id == 'unassigned-sr' }>
				<ResultsServiceRequests />
			</Expanding>
			<Expanding open={ params.widget_id == 'inprogress-sr' }>
				<ResultsServiceRequests />
			</Expanding>
			<Expanding open={ params.widget_id == 'completed-sr' }>
				<ResultsServiceRequests />
			</Expanding>
		</div>
	);
};
